import 'jquery-match-height';
import {matchHeight} from '../components/matchHeight';

export const boxWeather = () => {
    matchHeight('.c-box-weather__text');
}
